import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'C:\\DEV\\annuaire_em\\ent-041223\\node_modules\\css-loader\\dist\\runtime\\api.js'
import 'C:\\DEV\\annuaire_em\\ent-041223\\node_modules\\vue-style-loader\\lib\\addStylesShadow.js'
import 'C:\\DEV\\annuaire_em\\ent-041223\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js'

import vAnnuaire from '~root/src/App.vue?shadow'
window.customElements.define('v-annuaire', wrap(Vue, vAnnuaire))